import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "limit-exceptions-upload-page" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SettingsPageHeader = _resolveComponent("SettingsPageHeader")!
  const _component_UploadLimitExceptionsDialog = _resolveComponent("UploadLimitExceptionsDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SettingsPageHeader, null, {
      "title-content": _withCtx(() => [
        (_ctx.isMultibrandIconVisible)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.iconPageMultibrand,
              class: "limit-exceptions-upload-page__multibrand-icon"
            }, null, 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Limit exceptions upload", -1 /* CACHED */))
      ]),
      "actions-block": _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setUploadModalOpen(true)))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Upload ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_UploadLimitExceptionsDialog)
  ]))
}